import { InactivityTracker } from 'hb-react/shared/utils/InactivityPublisher/trackers/InactivityTracker';

export class UserActionsTracker extends InactivityTracker {
  constructor(timeoutMS: number) {
    super(timeoutMS);

    this.handleUserInteraction = this.handleUserInteraction.bind(this);
  }

  public init(onTrackerChange: () => void) {
    super.init(onTrackerChange);

    this.addEventListeners();
    this.startInactivityTimeout();
  }

  public destroy() {
    super.destroy();

    this.removeEventListeners();
    this.clearInactivityTimeout();
  }

  private addEventListeners() {
    window.addEventListener('mousemove', this.handleUserInteraction);
    window.addEventListener('keydown', this.handleUserInteraction);
  }

  private removeEventListeners() {
    window.removeEventListener('mousemove', this.handleUserInteraction);
    window.removeEventListener('keydown', this.handleUserInteraction);
  }

  private handleUserInteraction = () => {
    // We restart the inactivity timeout on every user interaction
    // The timeout will run out if the user stops interacting
    this.startInactivityTimeout();
  };
}
